import React from "react";
import { PdfExportA5 } from "../../orders-components/order_table_components/PdfExport";
import { fetchExchangeById } from "../controller/exchange-controller";
import { PdfExportMultiple } from "../../orders-components/order_table_components/PdfExport";
import { useState, useEffect } from "react";
// Component for printing a single exchange
const PrintExchange = ({ exchangeId }) => {
  const [exchange, setExchange] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const loadExchange = async () => {
      try {
        setIsLoading(true);
        const data = await fetchExchangeById(exchangeId);
        console.log('Loaded exchange for printing:', data);
        setExchange(data);
      } catch (err) {
        console.error('Error loading exchange for print:', err);
        setError(err.message || 'Impossible de charger les données de l\'échange');
      } finally {
        setIsLoading(false);
      }
    };

    if (exchangeId) {
      loadExchange();
    }
  }, [exchangeId]);

  if (isLoading) {
    return <div>Chargement de l'échange...</div>;
  }

  if (error) {
    return <div>Erreur: {error}</div>;
  }

  if (!exchange) {
    return <div>Aucune donnée d'échange disponible</div>;
  }

  // Map our exchange data to the format expected by PdfExportA5
  const orderForPrint = {
    ...exchange,
    id: exchange.id,
    reference: exchange.reference,
    dateBonCommande: exchange.dateEchange,
    totalTTC: exchange.totalTTC,
    clientFirstName: exchange.bonCommande?.clientFirstName,
    clientLastName: exchange.bonCommande?.clientLastName,
    clientEmail: exchange.bonCommande?.clientEmail,
    clientPhone: exchange.bonCommande?.clientPhone,
    clientNumber: exchange.bonCommande?.clientPhone,
    clientAdresse: exchange.bonCommande?.clientAddress,
    ville: exchange.bonCommande?.ville,
    codeLivraison: exchange.codeLivraison,
    items: exchange.items || []
  };

  return (
    <PdfExportA5 
      order={orderForPrint} 
      productItems={exchange.items || []}
      logo='/logo-print.png'
      mylerzLogo="/mylerz.png"
      isExchange={true} // This is the key parameter we're adding
    />
  );
};

// Component for printing multiple exchanges
// Updated BatchPrintExchanges component

const BatchPrintExchanges = ({ exchangeIds }) => {
  const [exchanges, setExchanges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExchanges = async () => {
      try {
        setLoading(true);
        // If we need to fetch exchange data by IDs
        const exchangePromises = exchangeIds.map(id => 
          typeof id === 'object' ? id : fetchExchangeById(id)
        );
        
        const results = await Promise.all(exchangePromises);
        
        // Format exchanges as orders for the PDF export
        const formattedExchanges = results.map(exchange => ({
          id: exchange.id,
          reference: exchange.reference || `ECH-${exchange.id}`,
          dateBonCommande: exchange.dateEchange || new Date().toISOString(),
          totalTTC: exchange.montantTotal || 0,
          clientName: exchange.client?.nom || 'Client',
          clientFirstName: exchange.client?.prenom || '',
          clientLastName: exchange.client?.nom || 'Client',
          clientNumber: exchange.client?.tel || '',
          clientAdresse: exchange.adresseLivraison || '',
          ville: exchange.ville || 'TUN',
          items: exchange.lignesEchange || []
        }));
        
        setExchanges(formattedExchanges);
      } catch (error) {
        console.error('Error fetching exchanges for batch print:', error);
      } finally {
        setLoading(false);
      }
    };

    if (exchangeIds && exchangeIds.length > 0) {
      fetchExchanges();
    }
  }, [exchangeIds]);

  if (loading) {
    return <div>Chargement des échanges pour impression...</div>;
  }

  if (!exchanges || exchanges.length === 0) {
    return <div>Aucun échange à imprimer</div>;
  }

  return (
    <PdfExportMultiple 
      orders={exchanges} 
      logo="/logo-print.png"
      mylerzLogo="/mylerz.png"
      isExchange={true}
    />
  );
};

export { PrintExchange, BatchPrintExchanges };
export default PrintExchange;